export default "__VITE_ASSET__abf75ac1__"